// src/components/Main.js
import React from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import '../App.css';
import '../responsive.css';



function Main() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Logout Error:', error);
    }
  };

  const navigateToRegister = () => {
    navigate('/');
  };

  return (
    // <div>
      <div className="logo-background"></div>
  );
}

export default Main;
